import { Stack, Typography, Box, useTheme, Tooltip } from '@mui/material'
import { HelpOutlineRounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { isArray } from 'lodash'
import { useAppSelector } from '../../store/hooks'
import { fsColors } from '../../shared/constants'

const TableView = ({ results, type, id, law }: { results: any; type: any; id: any; law: any }) => {
  const { currentLanguage } = useAppSelector((state) => state.currentUser)
  const { t } = useTranslation()
  const theme = useTheme()

  return results.map(({ label, value }: any, index: number) => (
    <Stack
      key={`type_${type.id}_section_${id}_${index}`}
      direction="row"
      justifyContent="space-between"
      mb={2}
      borderRadius={2}
      sx={{
        minWidth: '100%',
        display: 'inline-flex',
        backgroundColor: 'action.hover',
      }}
    >
      <Stack direction="row" alignItems="flex-start" mr={2} p={2} sx={{ minWidth: '200px' }}>
        <Typography>{t(label.text)}</Typography>
        {label.tooltipText && (
          <Tooltip
            title={
              <Box>
                <Typography fontWeight="bold">{`${t('etrl.kpi.occ.inc')}:`}</Typography>
                {label.tooltipText.map((ob: any) => (
                  <Box mt={1.5}>
                    <Typography>{`\r\n\u2022 ${t('pt.assistance.selected.occ.kldb')} ${
                      ob.kldb20105
                    }`}</Typography>
                    <Typography ml={1.5}>{`${
                      currentLanguage === 'de' ? ob.bezeichnungKldb : ob.titleKldb
                    }`}</Typography>
                  </Box>
                ))}
              </Box>
            }
            arrow
            placement="right"
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 600,
                },
              },
            }}
          >
            <HelpOutlineRounded
              fontSize="small"
              sx={{ ml: 1, mt: 0.25, color: fsColors.fsGray.colors[1] }}
            />
          </Tooltip>
        )}
      </Stack>
      <Stack direction="row" alignItems="flex-start" spacing={2}>
        {isArray(value) ? (
          value.map((val, vIndex) => (
            <Box
              key={`res_${index}_val_${vIndex}`}
              p={2}
              sx={{
                width: '200px',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderLeft: `4px solid ${theme.palette.background.paper}`,
              }}
            >
              {law === 'Abs. 1 Ziff. 7 (EU Art. 9, 1. g)' &&
              vIndex === 0 &&
              Number(val.value) > 5 ? (
                <Typography
                  component="div"
                  color="error.main"
                  variant="h5"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                >
                  {`\u2022`}
                  <Typography ml={1} mb={0.25} color="text.primary">
                    {val.value !== null
                      ? `${Number(val.value).toLocaleString(currentLanguage, {
                          maximumFractionDigits: 2,
                        })} %`
                      : 'NA'}
                  </Typography>
                </Typography>
              ) : (
                <Typography textAlign="center">
                  {val.value !== null
                    ? `${Number(val.value).toLocaleString(currentLanguage, {
                        maximumFractionDigits: 2,
                      })} %`
                    : 'NA'}
                </Typography>
              )}
            </Box>
          ))
        ) : (
          <Box
            p={2}
            key={`res_${index}_val`}
            sx={{
              width: '200px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderLeft: `4px solid ${theme.palette.background.paper}`,
            }}
          >
            <Typography textAlign="center">
              {value !== null
                ? `${Number(value).toLocaleString(currentLanguage, {
                    maximumFractionDigits: 2,
                  })} %`
                : 'NA'}
            </Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  ))
}

export default TableView
